// extracted by mini-css-extract-plugin
export default {"modalOverlay":"fK-z","modalContent":"gK-z","header":"hK-z","close":"iK-z"};